<template>
  <div class="hit-container hit-html-html">

  <div class="hit-container hit-html-html">

      <div class="hit-row">
        <div class="hit-col-md-12">
          <div class="hit-alert hit-alert-success">{{ $t("message.successfullValidated") }}</div>
        </div>
      </div>

    </div>

    <vote_conflict />

  </div>
</template>

<script>

import vote_conflict from '@core/components/content/app/vote_conflict'

export default{

  components: {vote_conflict},

  metaInfo: function () {
    return {
      title: this.$t('message.successfullValidated')
    }
  },

  methods: {

    vote_confirm (callback) {
      var send = {
        user: this.$route.params.userID,
        board: this.$route.params.boardID,
        ID: this.$route.params.entryID
      }

      var my_class = this

      this.$hit_post({url: 'hitclick/votes/confirm',
        data: send,
        callback: function (ret) {
          console.log(ret)

          if (!ret.data[0]) { return false }

          callback(ret.data[1])
        }})
    },

    send_chat (ret) {
      var send = {
        user: this.$route.params.userID,
        data: {
          chat_nr: this.$route.params.boardID + '-' + this.$route.params.entryID,
          msg: this.$tc('message.feedback', 1) + ' #' + ret.board + '-' + ret.ID + ' ' + this.$t('message.successfullValidated'),
          user: 2,
          view: [2]
        }
      }

      this.$store.dispatch('set_chat', send)
    },

    admin_notify (ret) {
      var send = {
        user: this.$route.params.userID,
        data: {
          msg: this.$tc('message.feedback', 1) + ' #' + ret.board + '-' + ret.ID + ' ' + this.$t('message.successfullSaved', 1),
          title: this.$t('message.successfullValidated'),
          board: ret.board,
          ID: ret.ID
        }
      }

      this.$hit_post({url: 'hitclick/votes/admin_notify',
        data: send,
        callback: function (ret) {

        }})
    }

  },

  created () {
    this.vote_confirm(function (ret) {
      this.send_chat(ret)
      this.admin_notify(ret)
    }.bind(this))
  }

}

</script>
